import { withInstall } from '@code-monkey-ui/utils'
import Autocomplete from './src/autocomplete.vue'

export const ElAutocomplete = withInstall(Autocomplete)

export default ElAutocomplete

export * from './src/autocomplete'
